import { useParams } from "react-router-dom";

import { VideoDetails } from "@/app/modules/ContentDetails";

export const Video = () => {
  const { id } = useParams();
  return <VideoDetails id={parseInt(id ?? "")} />;
};
